import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment (#session_id=xxx)
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data + session_token
        const response = await axios.post(
          `${API_BASE_URL}/api/auth/google/process-session`,
          { session_id: sessionId },
          { withCredentials: true }  // Important for cookies
        );

        const { user, session_token } = response.data;

        // Check if user is approved
        if (!user.is_approved) {
          // Redirect to pending approval page
          navigate('/pending-approval', { state: { user } });
          return;
        }

        // Store user in localStorage (optional, session_token in cookie is primary)
        localStorage.setItem('user', JSON.stringify(user));

        // Navigate to dashboard with user data
        navigate('/dashboard', { state: { user }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        alert('Authentication failed. Please try again.');
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, hsl(210, 75%, 55%) 0%, hsl(180, 52%, 48%) 100%)'
    }}>
      <div style={{ textAlign: 'center', color: 'white' }}>
        <div className="spinner" style={{ 
          width: '60px', 
          height: '60px', 
          margin: '0 auto 24px',
          borderColor: 'rgba(255,255,255,0.3)',
          borderTopColor: 'white'
        }}></div>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '8px' }}>
          Authenticating with Google
        </h2>
        <p style={{ fontSize: '1rem', opacity: 0.9 }}>
          Please wait...
        </p>
      </div>
    </div>
  );
}

export default AuthCallback;
